import { useQuery } from 'react-query'
import { fetchRetornarEmData } from '../services/retornarEmService'

export const useRetornarEmData = (codigo_usuario) => {
  const { data, isLoading } = useQuery({
    queryKey: ['retornarEmData', codigo_usuario],
    queryFn: () => fetchRetornarEmData(codigo_usuario),
    refetchOnWindowFocus: false,
  })

  return { data, loading: isLoading }
}
